import React, { useEffect, useRef } from "react";
import { getCourseDetailsAction } from "@src/components/Tabs/Overview/store/actions.js";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "@src/lib/router";

import { newWebEngage } from "@src/utils/webEngageEvent";
import { checkCourseStatus } from "@src/utils/goBack";
import OverviewShimmer from "./Overview/components";
import axios from "axios";
import getAxiosConfig from "@src/utils/getAxiosConfig";

import OverView from "./Overview/components";
import ContentHome from "./Content/components/ContentHome";
import TrialContent from "./Content/components/TrialContent/index";
import SavedQuestions from "./SavedQuestions";
import LiveClasses from "./LiveClasses";
import Announcements from "./Announcements";

function SwitchTabs({
  activeTab,
  overviewServerData,
  getCourseCouponListStudentDataServer,
}) {
  const dispatch = useDispatch();

  const router = useRouter();
  const state = useSelector((state) => state?.overviewReducer);
  const isFirstMount = useRef(true);
  const firedOnceWebEngage = useRef(false);
  const firedOnceBackendWebEngage = useRef(false);

  useEffect(() => {
    if (!state?.overViewDetails?.course?.details?.name) {
      if (router?.query?.courseId) {
        dispatch(
          getCourseDetailsAction({
            courseId: router?.query?.courseId,
            isLoading:
              overviewServerData && state?.overViewDetails?.course
                ? false
                : true,
            showPaymentLoader: !state?.graphCourseData?.priceBottom?.val,
          })
        );
      }
    }
    isFirstMount.current = false;
  }, []);
  const priceDetails = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.priceDetails
  );
  const courseData = useSelector(
    (state) => state?.overviewReducer?.graphCourseData
  );
  const metaData = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.metaData
  );
  const graphCouponState = useSelector(
    (state) => state?.overviewReducer?.graphCourseCouponListData
  );
  const orgDetails = useSelector(
    (state) => state?.persistedDataReducer?.orgDetails?.organization
  );

  const userDetails = useSelector(
    (state) => state?.overviewReducer?.userDetails?.responseData?.user
  );

  useEffect(() => {
    if (!firedOnceWebEngage.current) {
      hitCourseViewedEventWebEngage();
    }
    // window.webEngageReadyEvent = () => {
    //   hitCourseViewedEventWebEngage();
    // };
    if (
      state?.overViewDetails?.course?.details?.name &&
      (getCourseCouponListStudentDataServer?.totalCount != undefined ||
        graphCouponState?.totalCount != undefined) &&
      orgDetails?.name &&
      userDetails?.name &&
      !firedOnceBackendWebEngage.current
    ) {
      const backendWebEngage = {
        eventName: "Store Screen_Particular Course Clicked",
        action: "Course Clicked",
        courseId: router.query.courseId + "",
        org_id: orgDetails?.id + "",
        org_code: orgDetails?.code + "",
        user_type: "1",
        user_id: userDetails?.id + "",
        user_name: userDetails?.name + "",
      };

      axios({
        ...getAxiosConfig(
          "POST",
          () => `/v2/course/webEngage/event`,
          backendWebEngage
        ),
      })
        .then((res) => {
          console.log("res", res);
        })
        .catch((err) => {
          console.log("err", err);
        });

      firedOnceBackendWebEngage.current = true;
    }
    // window?.webengage?.onReady?.(function () {
    //   window?.webEngageReadyEvent?.();
    // });
  }, [state, graphCouponState, orgDetails, userDetails]);

  const hitCourseViewedEventWebEngage = () => {
    if (
      state?.overViewDetails?.course?.details?.name &&
      (getCourseCouponListStudentDataServer?.totalCount != undefined ||
        graphCouponState?.totalCount != undefined) &&
      orgDetails?.name &&
      userDetails?.name &&
      !firedOnceWebEngage.current &&
      courseData?.priceBottom
    ) {
      newWebEngage("course_overview", {
        action: "Course Clicked",
        has_viewed: !!metaData?.hasViewed,
        has_coupon:
          getCourseCouponListStudentDataServer?.totalCount > 0 ||
          graphCouponState?.totalCount > 0,
        course_name: state?.overViewDetails?.course?.details?.name + "",
        course_price: Number(priceDetails?.price),
        final_amount: Number(priceDetails?.totalPayableAmount / 100),
        course_status: checkCourseStatus(),
        max_discount: Number(priceDetails?.discount) || 0,
        coupon_code: "",
        after_coupon_amount: Number(priceDetails?.totalPayableAmount / 100),
        org_name: orgDetails?.name,
        coupon_type: courseData?.appliedCoupon?.label || "",
        has_free_content:
          state?.overViewDetails?.course?.freeContentCount > 0 ? true : false,
        course_views: state?.overViewDetails?.course?.returnFomo?.text || "",
        has_installment: state?.individualInstallmentData?.installmentInfo
          ?.installments?.length
          ? true
          : false,
        no_of_installments:
          state?.individualInstallmentData?.installmentInfo?.installments
            ?.length || 0,
        installment_amount:
          (
            state?.individualInstallmentData?.installmentInfo?.installments[0]
              ?.installmentPrice / 100
          )?.toFixed(2) || 0,
        is_price_slashed: courseData?.priceBottom?.decoratedText ? "Yes" : "No",
        discount_amount: courseData?.priceBottom?.decoratedText
          ? courseData?.priceBottom?.decoratedText.replace(/\/|,|₹|-/g, "") -
            courseData?.priceBottom?.finalPrice.replace(/\/|,|₹|-/g, "")
          : 0,
      });
      // initWebEngage(userDetails);
      firedOnceWebEngage.current = true;
      // window.webEngageReadyEvent = null;
      // alert(`WEBENGAGE EVENT HIT -- ${firedOnceWebEngage.current}`);
    }
  };

  switch (activeTab) {
    case 1:
      return (
        <OverView
          overviewServerData={overviewServerData}
          getCourseCouponListStudentDataServer={
            getCourseCouponListStudentDataServer
          }
          isFirstMount={isFirstMount.current}
        />
      );
    case 2:
      return <ContentHome />;
    case 3:
      return (
        <LiveClasses
          liveClassServerData={
            overviewServerData?.course?.upcomingLiveClasses?.data
          }
        />
      );
    case 4:
      return <Announcements />;
    case 5:
      return <TrialContent />;
    case 6:
      return <SavedQuestions />;
    default:
      return <OverviewShimmer />;
  }
}

export default SwitchTabs;
